import { createPageApp } from '@/lib/createPageApp'
import ViewUnitPage from './ViewUnitPage.vue'

createPageApp(ViewUnitPage).mount()
